export default "__VITE_ASSET__DlxAbUCx__"